import { render } from "./BuildingPermits.vue?vue&type=template&id=03903c92&scoped=true"
import script from "./BuildingPermits.vue?vue&type=script&lang=js"
export * from "./BuildingPermits.vue?vue&type=script&lang=js"

import "./BuildingPermits.vue?vue&type=style&index=0&id=03903c92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03903c92"]])

export default __exports__